import { IOnchangeFieldHelper } from '../../models/IOnchangeFieldHelper'

export const onChangePercentField =
  ({ onChange }: IOnchangeFieldHelper<number | null>) =>
  (value: string) => {
    if (!value) {
      onChange(null)
      return
    }
    onChange(Number(value))
  }
